import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-74107acc")

_pushScopeId("data-v-74107acc")
const _hoisted_1 = { class: "shopping-list-search-result-page" }
const _hoisted_2 = { class: "shopping-list-search-result-page-contents" }
const _hoisted_3 = { class: "shopping-list-search-result-page-contents-toparea" }
const _hoisted_4 = { class: "shopping-list-search-result-page-contents-toparea-input" }
const _hoisted_5 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingListSearchInputView = _resolveComponent("ShoppingListSearchInputView")
  const _component_ShoppingListSearchResultItem = _resolveComponent("ShoppingListSearchResultItem")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ShoppingListSearchInputView, {
            inputText: _ctx.initialKeyword,
            isValidFocus: false,
            onSetSearchword: _ctx.setSearchText
          }, null, 8, ["inputText", "onSetSearchword"])
        ])
      ]),
      _createVNode("div", {
        class: "shopping-list-search-result-page-contents-list",
        onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll($event)))
      }, [
        (_ctx.isCompleteSearch)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_ShoppingListSearchResultItem, {
                ingredientName: _ctx.rawName,
                isRawSearchString: _ctx.isRaw,
                onSelectItem: _ctx.selectRawItem
              }, null, 8, ["ingredientName", "isRawSearchString", "onSelectItem"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchResult, (ingredient) => {
          return (_openBlock(), _createBlock(_component_ShoppingListSearchResultItem, {
            class: "shopping-list-search-result-page-contents-list-item",
            key: ingredient.id,
            id: ingredient.id,
            imageUrl: ingredient.imageUrl,
            ingredientName: ingredient.name,
            onSelectItem: _ctx.selectItem
          }, null, 8, ["id", "imageUrl", "ingredientName", "onSelectItem"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 32)
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.apiErrorDialogType,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onNegativeClick: _ctx.cancelHandler,
      onPositiveClick: _ctx.retryHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowMessageDialog,
      dialogType: _ctx.messageDialogType,
      title: _ctx.messageDialogTitle,
      message: _ctx.messageDialogMessage,
      negativeLabel: _ctx.messageDialogNegativeLabel,
      positiveLabel: _ctx.messageDialogPositiveLabel,
      onNegativeClick: _ctx.messageDialogNegativeAction,
      onPositiveClick: _ctx.messageDialogPositiveAction
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "positiveLabel", "onNegativeClick", "onPositiveClick"])
  ]))
})